(function () {
    /** CONSTANTS */
    let SYNER_URL = "https://synerserver.herokuapp.com";
    const IS_TEST = true;

    if (
        window.location.href.indexOf("synerdevelopment.myshopify.com") > -1 ||
        window.location.href.indexOf("localhost") > -1
    ) {
        SYNER_URL = "http://localhost:8080";
    }

    const loadScript = function (url, callback) {
        const script = document.createElement("script");
        script.type = "text/javascript";

        // If the browser is Internet Explorer.
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        } else {
            script.onload = function () {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    let tries = 0;
    let existingTimeout = null;

    function buildField(settings, $) {
        let existingField = document.getElementsByClassName("syner_field_holder");
        if (existingField.length > 0) {
            console.log("existing field found")
            return;
        }

        let customClass = "";
        if (settings && settings.customClass) {
            customClass = settings.customClass;
        }
        const field_code =
            `
            <div class="cart-attribute__field syner_field_holder ` + customClass + `">
                <div class="help-tip">
                    <p style="display: none; position: absolute;" >` +
            settings.helptext1 +
            ` <br/>` +
            settings.helptext2 +
            `
                        <br/>
                        <span style="font-size: 8px">
                            Powered by <a href="https://www.syner.co/promotioninstructions" style="color: white; font-size: 8px !important;"><u style="color: white; font-size: 8px !important;">Syner.</u></a>
                        </span>
                    </p>
                </div>
                 <label id="instagram-name-label" for="instagram-name">` +
            settings.title +
            `</label>
                <div class="synerinstafield">
				            <input id="instagram-name" class="input-group__field newsletter__input" type="text" name="attributes[Instagram name]" value="" placeholder="` +
            settings.placeholder +
            `" />
                </div>
		    </div>
        `;
        let location = "syner_insta_field_holder";
        if (settings.location) {
            console.log("Using custom syner location: " + settings.location);
            location = settings.location;
        } else if (window.location.href.indexOf("test-voorbeeld-winkel") > -1) {
            location = "footer-row";
        }

        const elements = document.getElementsByClassName(location);

        if (elements.length > 0) {
            const first = elements[0];
            let fieldDiv = document.createElement('div');
            fieldDiv.className = customClass + "_outer";
            fieldDiv.innerHTML = field_code;
            first.appendChild(fieldDiv);
            first.addEventListener("change", (event) => {
                console.log("Change");
                $.post("/cart/update.js", {
                    attributes: {
                        instagramName: event.target.value,
                    },
                });
            });
            first.addEventListener("click", (event) => {
                $.post("/cart/update.js", {
                    attributes: {
                        synerTracker: "click",
                    },
                });
            });
        } else {
            console.log(tries + ": no elements found, looking for: ", location);
            if (tries < 20) {
                setTimeout(() => {
                    tries++;
                    buildField(settings, $);
                }, 1000);
            }
        }
    }

    function addPromoteButton($) {
        const field_code = `Discount on your next purchase? <svg style="margin-left: 5px; margin-bottom: -3px" width="20" height="20" viewBox="0 0 1821 1421" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="487" cy="934" r="487" fill="black"/>
      <path d="M950.002 612.999L1820.09 434.718L1595.28 1223.28L950.002 612.999Z" fill="black"/>
      <circle cx="1149" cy="203" r="203" fill="black"/>
      </svg>`;
        const elements = document.getElementsByClassName("syner_promote_button");
        if (elements.length > 0) {
            var modal = document.getElementById("syner_popup");
            const first = elements[0];
            first.innerHTML = field_code;
            first.onclick = function () {
                const cartClosers = document.getElementsByClassName(
                    "cart-drawer__close-button"
                );
                for (let i = 0; i < cartClosers.length; i++) {
                    cartClosers[i].click();
                }

                modal.style.display = "block";
                const findModal = document.getElementsByClassName("modal-content");
                if (findModal.length > 0) {
                    const first = findModal[0];
                    first.style.display = "block";
                }
                const findModalSuccess = document.getElementsByClassName(
                    "modal-content-success"
                );
                if (findModalSuccess.length > 0) {
                    const first = findModalSuccess[0];
                    first.style.display = "none";
                }
            };
            window.onclick = function (event) {
                if (event.target === modal) {
                    modal.style.display = "none";
                }
            };
        } else {
            console.log(
                "no button elements found, looking for: syner_promote_button"
            );
            if (tries < 5) {
                setTimeout(() => {
                    tries++;
                    addPromoteButton($);
                }, 500);
            }
        }
    }

    function invalidEmail(email) {
        let validEmail =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !validEmail.test(email);
    }

    function invalidInsta(insta) {
        return insta.length === 0;
    }

    function signUpForPromotion(email, insta) {
        return new Promise((resolve, reject) => {
            let shop = "test-voorbeeld-winkel.myshopify.com";
            if (typeof Shopify !== "undefined") {
                shop = Shopify.shop;
            }

            fetch(SYNER_URL + "/api/signup", {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    insta: insta,
                    shopDomain: shop,
                }),
            }).then((response) => {
                if (!response.ok) {
                    reject();
                }
                resolve();
            });
        });
    }

    async function addModal($, data) {
        const modalCode =
            `<div class="modal-content">
        <form>
          <div>
            <div id="syner_close_button" class="syner_close"/>
          </div>
          <div class="modal-logo">
            <img src="` +
            data.url +
            `" alt="modal-logo" class="modal-logo-img"/>
          </div>
          <div class="modal-subtitle">
            Promote your next purchase on instagram after receiving it to get a discount on your next order.
          </div>
          <div>
            <span id="syner_input_email_error" class="syner_error_text"></span>
            <input id="syner_input_email" class="syner_input" placeholder="Email"/>
          </div>
          <div>
            <span id="syner_input_insta_error" class="syner_error_text"></span>
            <input id="syner_input_insta" class="syner_input" placeholder="@yourinstagramname"/>
          </div>
          <div id="syner_modal_button" class="syner_button">Promote for a discount</div>
        </form>
        </div>
        </div>
        <div class="modal-content-success">
            <div class="modal-logo">
            <img src="` +
            data.url +
            `" alt="modal-logo" class="modal-logo-img"/>
            </div>
            <div class="modal-subtitle">
              Thanks for signing up, we will sent you the instructions shortly.
            </div>
            <div id="syner_modal_button_close" class="syner_button">Close</div>
      </div>`;
        const modal = document.getElementById("syner_popup");
        if (modal !== null) {
            modal.innerHTML = modalCode;
            const modalButton = document.getElementById("syner_modal_button");
            modalButton.onclick = () => {
                let mailError = document.getElementById("syner_input_email_error");
                let instaError = document.getElementById("syner_input_insta_error");
                mailError.innerHTML = ``;
                instaError.innerHTML = ``;

                let email = document.getElementById("syner_input_email").value;
                let insta = document.getElementById("syner_input_insta").value;
                if (invalidEmail(email)) {
                    mailError.innerHTML = `Please enter a valid email address`;
                    return;
                }
                if (invalidInsta(insta)) {
                    instaError.innerHTML = `Please enter a valid instagram account`;
                    return;
                }
                signUpForPromotion(email, insta)
                    .then(() => {
                        const findModal = document.getElementsByClassName("modal-content");
                        if (findModal.length > 0) {
                            const first = findModal[0];
                            first.style.display = "none";
                        }
                        const findModalSuccess = document.getElementsByClassName(
                            "modal-content-success"
                        );
                        if (findModalSuccess.length > 0) {
                            const first = findModalSuccess[0];
                            first.style.display = "block";
                        }
                    })
                    .catch(() => console.log("Not ok"));
            };
            let closeButton = document.getElementById("syner_modal_button_close");
            closeButton.onclick = () => {
                modal.style.display = "none";
            };

            let closeButton2 = document.getElementById("syner_close_button");
            closeButton2.onclick = () => {
                modal.style.display = "none";
            };
        } else {
            console.log("no modal found, looking for: syner_popup");
            if (tries < 5) {
                setTimeout(() => {
                    tries++;
                    addModal($, data);
                }, 500);
            }
        }
    }

    let lookingForShopify = 0;

    const myAppJavaScript = function ($) {
        let shop = "test-voorbeeld-winkel.myshopify.com";
        if (typeof Shopify !== "undefined") {
            shop = Shopify.shop;
        } else if (lookingForShopify < 10) {
            setTimeout(() => {
                lookingForShopify++;
                console.log("No shopify store? Checking again..")
                myAppJavaScript($);
            }, 500);
            return ''
        }

        fetch(SYNER_URL + "/api/field?shopDomain=" + shop)
            .then(async (response) => {
                if (!response.ok) {
                    return;
                }
                const data = await response.json();
                if (data.enabled === false) {
                    console.log("Syner field is disabled");
                    return;
                }
                if (window.location.href.indexOf("cart") > -1 || IS_TEST) {
                    setTimeout(() => {
                        const firmhouse = document.getElementsByClassName("firmhouse-storefront");
                        if (firmhouse.length > 0) {
                            console.log("Found firmhouse cart");
                            // Some carts remove the whole cart on close. Add observer to see if we need to add field again
                            let observer = new MutationObserver(() => {
                                clearTimeout(existingTimeout);
                                existingTimeout = setTimeout(() => {
                                    buildField(data, $);
                                }, 500);
                            })
                            observer.observe(firmhouse[0], {
                                childList: true
                            })
                        } else {
                            console.log("not firmhouse")
                        }
                    }, 200);

                    buildField(data, $);
                }
            })
            .catch((e) => {
                console.error(e);
                console.log("could not fetch syner field");
            });
        fetch(SYNER_URL + "/api/popup?shopDomain=" + shop)
            .then(async (response) => {
                if (!response.ok) {
                    return;
                }
                const data = await response.json();
                if (data.enabled === false) {
                    console.log("Syner popup is disabled");
                    return;
                }
                console.log(data);
                await addModal($, data);
                addPromoteButton($);
            })
            .catch((e) => {
                console.error(e);
                console.log("could not fetch syner field");
            });
    };

    if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
        loadScript(
            "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
            function () {
                let jQuery191 = jQuery.noConflict(true);
                myAppJavaScript(jQuery191);
            }
        );
    } else {
        myAppJavaScript(jQuery);
    }
})();
